import api from '../api-methods'

const proxyHr = process.env.VUE_APP_ENV === 'local' ? '/proxy_hr' : process.env.VUE_APP_API_HR
const proxyApi = process.env.VUE_APP_ENV === 'local' ? '/proxy_api' : process.env.VUE_APP_API
const proxyMl = process.env.VUE_APP_ENV === 'local' ? '/proxy_ai' : process.env.VUE_APP_ML

const recommend = {
  // cvs_to_job
  cvsToJob: payload => {
    return api.get(proxyHr + `/v4/recommender/cvs_to_job`, payload)
  },

  // joblist_to_job
  joblistToJob: payload => {
    return api.post(proxyHr + `/v4/recommender/joblist_to_job`, payload)
  },

  // job_to_job
  jobToJob: payload => {
    return api.get(proxyHr + `/v4/recommender/job_to_job`, payload)
  },

  // job_to_job
  editorToJob: payload => {
    return api.get(proxyHr + `/v4/recommender/editor_to_job`, payload)
  },

  // download_to_job
  downloadToJob: payload => {
    return api.get(proxyHr + `/v4/recommender/download_to_job`, payload)
  },

  // download_to_job
  jobScanToJob: payload => {
    return api.get(proxyHr + `/v4/recommender/jobscan_to_job`, payload)
  },

  // career_to_job
  careerToJob: payload => {
    return api.post(proxyHr + `/v4/recommender/career_to_job`, payload)
  },

}

export default recommend
